import DeleteUserModule from './DeleteUser.module';

export * from './DeleteUserModuleProps';
export default DeleteUserModule;
